(function () {
  'use strict';

  if (window.PGCartScrollUnlockV13) return;
  window.PGCartScrollUnlockV13 = true;

  var unlockTimer = null;
  var observer = null;

  function isRendered(element) {
    if (!element || !element.getBoundingClientRect) return false;
    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();

    return style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      parseFloat(style.opacity || '1') > 0.02 &&
      rect.width > 1 &&
      rect.height > 1;
  }

  function isOnScreen(element) {
    if (!isRendered(element)) return false;
    var rect = element.getBoundingClientRect();
    return rect.right > 2 && rect.left < window.innerWidth - 2 && rect.bottom > 2 && rect.top < window.innerHeight - 2;
  }

  function cartDrawerIsOpen() {
    var drawer = document.querySelector('.cart_content');
    if (!drawer) return false;

    var trigger = document.querySelector('.mini_cart.active_link, .mini_cart.is-active, .mini_cart[aria-expanded="true"]');
    if (trigger) return true;

    if (drawer.getAttribute('aria-hidden') === 'false') return true;
    if (drawer.matches('.active, .is-active, .active_link, .open, [data-open="true"]')) return true;

    return isOnScreen(drawer);
  }

  function anotherOverlayIsOpen() {
    if (document.querySelector('details[data-mobile-menu][open]')) return true;

    var selectors = [
      '[role="dialog"][aria-hidden="false"]',
      '.modal.is-active',
      '.modal.active',
      '.modal.open',
      '.fancybox-is-open',
      '.quick-shop.active',
      '.quick-shop.is-active',
      '.search-container.is-active',
      '.search-container.active'
    ];

    var nodes = document.querySelectorAll(selectors.join(','));
    for (var index = 0; index < nodes.length; index += 1) {
      if (isOnScreen(nodes[index])) return true;
    }

    return false;
  }

  function staleLockExists() {
    var html = document.documentElement;
    var body = document.body;
    if (!body) return false;

    var bodyStyle = window.getComputedStyle(body);
    var htmlStyle = window.getComputedStyle(html);

    return body.classList.contains('blocked-scroll') ||
      body.classList.contains('pg-drawer-open') ||
      html.classList.contains('blocked-scroll') ||
      html.classList.contains('pg-drawer-open') ||
      bodyStyle.position === 'fixed' ||
      bodyStyle.overflow === 'hidden' ||
      htmlStyle.overflow === 'hidden';
  }

  function savedScrollPosition() {
    var body = document.body;
    if (!body) return window.pageYOffset || 0;

    var top = parseInt(body.style.top || '0', 10);
    if (Number.isFinite(top) && top < 0) return Math.abs(top);
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function clearInlineLock(element) {
    if (!element) return;

    ['overflow', 'overflow-y', 'position', 'top', 'left', 'right', 'width', 'height', 'touch-action']
      .forEach(function (property) {
        element.style.removeProperty(property);
      });
  }

  function unlockWhenSafe() {
    unlockTimer = null;

    if (cartDrawerIsOpen() || anotherOverlayIsOpen() || !staleLockExists()) return;

    var scrollY = savedScrollPosition();
    var html = document.documentElement;
    var body = document.body;

    body.classList.remove('blocked-scroll', 'pg-drawer-open', 'overflow-hidden', 'no-scroll');
    html.classList.remove('blocked-scroll', 'pg-drawer-open', 'overflow-hidden', 'no-scroll');

    clearInlineLock(body);
    clearInlineLock(html);

    window.requestAnimationFrame(function () {
      window.scrollTo(0, scrollY);
      window.dispatchEvent(new Event('resize'));
      document.dispatchEvent(new CustomEvent('pg:cart-unlocked'));
    });
  }

  function scheduleUnlock(delay) {
    window.clearTimeout(unlockTimer);
    unlockTimer = window.setTimeout(unlockWhenSafe, delay == null ? 80 : delay);
  }

  function schedulePasses() {
    [40, 120, 260, 520, 900].forEach(function (delay) {
      window.setTimeout(unlockWhenSafe, delay);
    });
  }

  function closeIntent(target) {
    if (!target || !target.closest) return false;

    return Boolean(target.closest([
      '.pg-drawer-close',
      '[data-cart-close]',
      '[data-cart-drawer-close]',
      '[aria-label="Close cart"]',
      '.cart_content__continue-shopping',
      '.mini-cart__close',
      '.cart-drawer__close'
    ].join(',')));
  }

  function init() {
    document.addEventListener('click', function (event) {
      if (closeIntent(event.target)) schedulePasses();
      else scheduleUnlock(180);
    }, true);

    document.addEventListener('touchend', function (event) {
      if (closeIntent(event.target)) schedulePasses();
    }, true);

    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape') schedulePasses();
    });

    document.addEventListener('transitionend', function (event) {
      if (event.target && event.target.matches && event.target.matches('.cart_content, .cart_content *')) {
        scheduleUnlock(20);
      }
    }, true);

    document.addEventListener('cart:refresh', function () { scheduleUnlock(180); });
    window.addEventListener('pageshow', function () { scheduleUnlock(20); }, { passive: true });

    if (window.jQuery) {
      window.jQuery(document).on('cart.requestComplete', function () { scheduleUnlock(180); });
    }

    if (window.MutationObserver) {
      observer = new MutationObserver(function () { scheduleUnlock(80); });
      observer.observe(document.documentElement, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['class', 'style', 'aria-hidden', 'aria-expanded', 'open']
      });
    }

    scheduleUnlock(20);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
